"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryValidationDto = exports.DeleteHeadsDtoValidation = exports.EditHeadDtoValidation = exports.HeadLocation = void 0;
const yup = require("yup");
const app_1 = require("./app");
var HeadLocation;
(function (HeadLocation) {
    HeadLocation["CENTER"] = "center";
    HeadLocation["CENTER_3_4_TOE"] = "center_3_4_toe";
    HeadLocation["CENTER_3_4_HEEL"] = "center_3_4_heel";
    HeadLocation["HIGH_CENTER"] = "high_center";
    HeadLocation["HIGH_CENTER_3_4_TOE"] = "center_3_4_toe";
    HeadLocation["HIGH_CENTER_3_4_HEEL"] = "center_3_4_heel";
    HeadLocation["LOW_CENTER"] = "low_center";
    HeadLocation["LOW_CENTER_3_4_TOE"] = "low_center_3_4_toe";
    HeadLocation["LOW_CENTER_3_4_HEEL"] = "low_center_3_4_heel";
})(HeadLocation = exports.HeadLocation || (exports.HeadLocation = {}));
exports.EditHeadDtoValidation = yup.object({
    id: yup.string().required(),
    number_sku: yup.string().nullable(),
    groove_sku: yup.string().nullable(),
    groove_number: yup.number().nullable(),
    image_url: yup.string().nullable(),
    product_description: yup.string().nullable(),
    type: yup.string().nullable(),
    oem: yup.string().required(),
    stated_head: yup.string().nullable(),
    stated_shaft: yup.string().nullable(),
    stated_ball: yup.string().nullable(),
    ball_flt: yup.array().of(yup.string()).nullable(),
    avalible_y_n: yup.string().nullable(),
    avalible_date: yup.date().nullable(),
    handycap_range_low: yup.number().nullable(),
    handycap_range_high: yup.number().nullable(),
    map_price: yup.number().nullable(),
    whs_cost: yup.number().nullable(),
    net_cost: yup.number().nullable(),
    stated_loft: yup.number().nullable(),
    measured_loft: yup.number().nullable(),
    ajustable_deg: yup.number().nullable(),
    hand_rh_lh: yup.string().nullable(),
    price: yup.string().nullable(),
    product_id: yup.number().nullable(),
    variant_id: yup.number().nullable(),
    averageRobotDataId: yup.string().nullable(),
    date_updated: yup.date().nullable(),
    deletedAt: yup.date().nullable(),
});
exports.DeleteHeadsDtoValidation = yup.object({
    ids: yup.array().of(yup.number()).min(1).required(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    searchFilter: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=heads.js.map